import Grid from "apollo-react/components/Grid";
import TrialCard from "./reviews_card";
import FiltersPanel from "./FiltersPanel";
import { useEffect, useState } from "react";
import { getFilteredStatusData, matchesDateFilter } from "./tabUtils";
import "./styles.css";

const ReviewsListCards = ({ requestsProgresses, route, isCoreValidator, onComplete, persona, currentTab }) => {
  const [filters, setFilters] = useState({
    referenceOrStudyName: "",
    dateRange: null, // Will store {startDate, endDate} or null
    statusFilter: "all" // New filter for IRB and RA tabs
  });
  const [filteredProgresses, setFilteredProgresses] = useState([]);
  
  // Set initial data
  useEffect(() => {
    setFilteredProgresses(requestsProgresses || []);
  }, [requestsProgresses]);

  // Reset status filter when changing tabs
  useEffect(() => {
    setFilters(prev => ({
      ...prev,
      statusFilter: "all"
    }));
  }, [currentTab]);

  const handleComplete = async (completedId) => {
    if (onComplete) {
      await onComplete();
    }
  };

  // Handle input changes without immediate filtering
  const handleFilterChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Apply filters only when button is clicked
  const handleApplyFilters = () => {
    if (!requestsProgresses) return;
    
    // Apply status filtering first (for IRB/RA tabs)
    const dataToFilter = getFilteredStatusData(
      persona, 
      currentTab, 
      filters.statusFilter, 
      isCoreValidator, 
      requestsProgresses
    );

    const filtered = dataToFilter.filter((progress) => {
      // Search in both reference number and study name
      const searchTerm = filters.referenceOrStudyName.toLowerCase();
      const referenceOrStudyNameMatch = !searchTerm || 
        progress.request.reference_number?.toLowerCase().includes(searchTerm) ||
        progress.request?.study_name?.toLowerCase().includes(searchTerm);

      // Date range filter using utility function
      const dateMatch = matchesDateFilter(progress, filters.dateRange);

      return referenceOrStudyNameMatch && dateMatch;
    });

    setFilteredProgresses(filtered);
  };

  return (
    <Grid container spacing={2}>
      {/* Filter Section */}
      <Grid item xs={3}>
        <FiltersPanel
          filters={filters}
          onFilterChange={handleFilterChange}
          onApplyFilters={handleApplyFilters}
          currentTab={currentTab}
          isCoreValidator={isCoreValidator}
          persona={persona}
        />
      </Grid>

      {/* Clinical Trials List */}
      <Grid item xs={9}>
        {filteredProgresses?.map((trial, index) => (
          <TrialCard
            key={index}
            route={route}
            requestProgress={trial}
            isCoreValidator={isCoreValidator}
            onComplete={handleComplete}
            persona={persona}
            showLoading={index === 0}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default ReviewsListCards;